<template>

    <div class="container-center">

        <el-form class="invite-form" label-width="140px" ref="form" :model="form" :rules="rules">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="产品及服务：" prop="serviceArray">
                        <el-select v-model="form.serviceArray" size="100" filterable multiple placeholder="请选择">
                            <el-option
                                v-for="item in productList"
                                :key="item.fid"
                                :label="item.fnameL2"
                                :value="item.fid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="3" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getPerevaList"
                               icon="el-icon-search">搜索
                    </el-button>
                </el-col>
            </el-row>
        </el-form>

        <div class="no-data-tip" v-if="tableData.length == 0"></div>

        <el-table v-else class="graphicTable" :data="tableData" style="width: 100%">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="productName" label="产品及服务"></el-table-column>
            <el-table-column prop="conNum" label="合同份数"></el-table-column>
            <el-table-column prop="avgScore" label="得分"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="singleContractJump(scope.row.productId)">
                        <span>明细</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="form.pageNum"
                :total="tableDataTotal"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import filter from '@/filter'
    import banner from '@/assets/imgs/banner_invite.png'
    import util from '@/util'

    export default {
        name: 'peeva-list',
        data () {
            return {
                loading: false,
                rules: {},
                tableData: [],
                tableDataTotal: 0,
                form: {
                    stockId: this.$root.stockId || '',
                    serviceArray: [],
                    pageNum: 1,
                    pageSize: 10
                },
                productList: []
            }
        },
        methods: {
            singleContractJump (productId) {
                this.$parent.$parent.$parent.tagJump(productId);
            },
            getPerevaList () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                        this.$http.post('rest/api/ContractPerformance/supplierPerformanceScore', this.form).then((res) => {
                            loading.close()
                            if (res.data.result) {
                                this.tableData = res.data.value.list
                                this.tableDataTotal = res.data.value.count
                                this.form.pageNum = res.data.value.pageNo
                            } else {
                                this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                            }
                        })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            handleCurrentChange (page) {
                this.form.pageNum = page
                this.getPerevaList()
            }
        },
        created () {

        },
        mounted () {
            this.getPerevaList()
        },

    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    .invite-form {
        background: #F5F6F5;
        padding: 25px 10px 10px 10px;
        margin: 24px 0;
    }

    .echart-box {
        height: 330px;
        width: 500px;
        margin-left: 28%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/pfeva/PerformanceEvaList.vue